import type { AgentApiCandidateProfilesItem, AgentApiTagsRecord } from '@/types/serializers';

export type CandidateRecipient = {
  id: number;
  name: string;
  age: number | null;
  organizationUserName: string | null;
  email?: string | null;
  tags?: AgentApiTagsRecord[];
};

export function hasEmail(candidate: AgentApiCandidateProfilesItem): boolean {
  return (candidate.email ?? '').trim().length > 0;
}

export function toRecipient(candidate: AgentApiCandidateProfilesItem): CandidateRecipient {
  return {
    id: candidate.id,
    name: candidate.name,
    age: candidate.age,
    organizationUserName: candidate.organization_users?.[0]?.name ?? null,
    email: candidate.email ?? null,
    tags: candidate.tags ?? [],
  };
}

export function recipientLabel(recipient: CandidateRecipient): string {
  return recipient.email ? `${recipient.name} <${recipient.email}>` : recipient.name;
}
